import { render, staticRenderFns } from "./nuevo.vue?vue&type=template&id=21871eb6&scoped=true"
import script from "./nuevo.vue?vue&type=script&lang=js"
export * from "./nuevo.vue?vue&type=script&lang=js"
import style0 from "./nuevo.vue?vue&type=style&index=0&id=21871eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21871eb6",
  null
  
)

export default component.exports